import { GeotabSensor, Key } from "../../models";
import { runAction } from "../client";
import { assertId } from "./common";

export interface GeotabSensorsRequestData
{
    VehicleId: Key;
    ExcludeRegistered: boolean;
}

export interface GeotabSensorsResult
{
	GeotabSensors: GeotabSensor[];
}

export type GetGeotabSensorsFn = (vehicleId: Key) => Promise<GeotabSensorsResult>;
export const getGeotabSensors: GetGeotabSensorsFn = (vehicleId: Key) => {
    assertId({ vehicleId });

    const payload: GeotabSensorsRequestData = {
        VehicleId: vehicleId,
        ExcludeRegistered: true
    };

    return runAction<GeotabSensorsResult>('/action/GetGeotabSensors', payload);
};



// WEBPACK FOOTER //
// ./src/rest/Geotab/sensors.ts